import { Inject, Injectable } from '@angular/core';
import { ResourceService } from '../../core/data-access/resource.service';
import { API_CONFIG, ApiConfig } from '../../core/models/api-config.model';
import { Installation } from '../model/installation';

@Injectable({ providedIn: 'root' })
export class InstallationService extends ResourceService<Installation, number> {
  
  constructor(@Inject(API_CONFIG) config: ApiConfig) {
    super("installations",config.apiUrl);
  }
  
}
